<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item :label="activeName==1?'业务员信息：':'客户信息：'">
            <el-input v-model="query.nameorpho" placeholder="请输入姓名/手机号" size="small" />
          </el-form-item>
          <el-form-item :label="activeName==1?'业务身份：':'客户身份：'">
            <el-select v-model="query.clevel" placeholder="请选择" clearable size="small" v-if="activeName==1">
              <el-option v-for="item in options.businessStanding" :key="item.id" :label="item.name" :value="item.level"></el-option>
            </el-select>
            <el-select v-model="query.clevel" placeholder="请选择" clearable size="small" v-if="activeName==2">
              <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="客户信息："  v-if="activeName==2">
            <el-input v-model="query.nameorpho" placeholder="请输入姓名/手机号" size="small" />
          </el-form-item>
          <el-form-item label="客户身份："  v-if="activeName==2">
            <el-select v-model="query.clevel" placeholder="请选择客户身份" clearable size="small">
              <el-option :label="item.name" :value="item.level" v-for="item in standingList" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="客户状态：" prop="customerRelationType" v-if="activeName==2">
            <el-select v-model="query.customerRelationType" placeholder="请选择客户状态" clearable size="small">
              <el-option label="开发客户" :value="1"></el-option>
              <el-option label="继承客户" :value="0"></el-option>
              <el-option label="未建立关系" :value="-1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
            <el-button type="info" @click="handleBack" plain size="mini">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="团队" name="1"></el-tab-pane>
          <el-tab-pane label="直属客户" name="2"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button> -->
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">转为继承客户</el-button>
          <el-button type="primary" size="mini" @click="handleCreateDevelopment" icon="el-icon-plus">转为开发客户</el-button>
        </div>
      </div>
      <el-table ref="table" v-loading="listLoading" :data="list" @selection-change="selectionChange" style="width: 100%;" :key="tableKey + '-' + activeName" :row-key="getRowKey" :lazy="activeName==='1'" :load="loadTree" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :header-cell-class-name="setTableHeaderClass">
        <el-table-column type="selection" width="50" :selectable="checkSelectable" />
        <el-table-column align="center" width="30" />
        <el-table-column label="用户信息" prop="" align="center" width="120">
          <template slot-scope="{row}">
            <div @click="handleShow(row)">
              <el-link type="primary" :class="{'placeholder-text': row.isPlaceholder}">{{row.customer.name}}</el-link><br />
              <el-link type="primary" :class="{'placeholder-text': row.isPlaceholder}">{{row.customer.pho}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="身份" prop="" align="center" width="110">
          <template slot-scope="{row}">
            <span :class="{'placeholder-text': row.isPlaceholder}">{{ getRowClevelText(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户状态" prop="" align="center" width="110">
          <template slot-scope="{row}">
            <span :class="{'placeholder-text': row.isPlaceholder}">
              {{ row.customerRelationType === 1 ? '开发客户' : (row.customerRelationType === 0 ? '继承客户' :
                (row.customerRelationType === -1 ? '未建立关系' : '')) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上级信息" prop="" align="center" width="200" v-if="activeName==='1'">
          <template slot-scope="{row}">
            <div v-if="!isChildCustomer(row)">
              <span type="primary" v-if="row.parentCustomer" :class="{'placeholder-text': row.isPlaceholder}">{{row.parentCustomer.name}}
                ({{ getParentClevelText(row) }})<br />{{row.parentCustomer.pho}}</span>

            </div>
          </template>
        </el-table-column>
        <el-table-column label="直属客户" prop="kehuCount" align="center" v-if="activeName==='1'">
          <template slot-scope="{row}">
            <span v-if="!isChildCustomer(row)">{{row.kehuCount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="入职时间" prop="customer.joinTime" align="center" v-if="activeName==='1'">
          <template slot-scope="{row}">
            <span v-if="!isChildCustomer(row)">{{row.customer.joinTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="加盟时间" prop="customer.joinTime" align="center">
          <template slot-scope="{row}">
            <span v-if="activeName==='2' || isChildCustomer(row)">{{row.customer && row.customer.joinTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="转入时间" prop="customer.recruitingTime" align="center">
          <template slot-scope="{row}">
            <span v-if="activeName==='2' || isChildCustomer(row)">{{row.customer && row.customer.recruitingTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operated.realName" align="center" />
        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="{row}">
            <template v-if="!row.isPlaceholder">
              <!-- 如果是直属客户标签页，显示单个操作按钮 -->
              <template v-if="activeName == '2'">
                <el-button type="text" @click="handleSingleUpdate(row,0)" v-if="row.customerRelationType !== 0">转为继承客户</el-button>
                <el-button type="text" @click="handleSingleUpdate(row,1)" v-if="row.customerRelationType !== 1">转为开发客户</el-button>
              </template>
              <!-- 如果是团队标签页，根据客户类型显示不同按钮 -->
              <template v-else>
                <!-- 如果是子级客户，显示单个操作按钮 -->
                <template v-if="isChildCustomer(row)">
                  <el-button type="text" @click="handleSingleUpdate(row,0)" v-if="row.customerRelationType !== 0">转为继承客户</el-button>
                  <el-button type="text" @click="handleSingleUpdate(row,1)" v-if="row.customerRelationType !== 1">转为开发客户</el-button>
                </template>
                <!-- 如果是父级客户，显示全部操作按钮 -->
                <template v-else>
                  <el-button type="text" @click="handleUpdate(row,1)">全部转为继承客户</el-button>
                  <el-button type="text" @click="handleUpdate(row,2)">全部转为开发客户</el-button>
                </template>
              </template>
              <!-- <el-button type="text" @click="handleLog(row)">日志记录</el-button> -->
            </template>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import customerLevelApi from '@/api/sys/customerLevel'
import Pagination from '@/components/Pagination'
import cityCompanyVue from '@/views/client/clientList/cityCompany.vue'
import userApi from '@/api/sys/user'
import customerApi from '@/api/technical/customer'
export default {
  props: ['rowId', 'ywId'],
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      formVisible: false,
      tableKey: 0,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      activeName: '1',
      standingList: [],
      technicianList: [],
      options: {
        businessStanding: [],
        identityOptions: []
      },
    }
  },
  created() {
    this.doQueryList({
      pageNo: 1
    })
    this.getBusinessStanding()
    this.getStandingList()
  },
  methods: {
    setTableHeaderClass({ column, columnIndex }) {
      // 条件：1. 是团队标签页（activeName === '1'）；2. 是选择列（type === 'selection'）
      if (this.activeName === '1' && column.type === 'selection') {
        // 返回隐藏类（后续在样式中定义）
        return 'hide-selection-header';
      }
      // 其他情况不添加样式
      return '';
    },
    handleBack() {
      this.$emit('handleShow', this.rowId, 1)
    },
    // 强制刷新表格并重新请求数据（解决懒加载子级不刷新的问题）
    forceRefresh(pageNo) {
      this.tableKey++
      this.doQueryList({ pageNo: pageNo || this.query.pageNo })
    },
    // 检查行是否可选择（不显示复选框）
    checkSelectable(row) {
      // 如果是占位行（暂无数据），则不显示复选框
      if (row.isPlaceholder) {
        return false
      }

      // 在团队标签页中，父级客户（非子级客户）的复选框置灰不可选
      if (this.activeName === '1' && !this.isChildCustomer(row)) {
        return false
      }

      // 其他情况可以选择
      return true
    },
    // 判断是否为子级客户
    isChildCustomer(row) {
      // 根据业务逻辑判断，这里可以根据实际需求调整判断条件
      // 例如：如果存在 customerRelationType 字段，说明是子级客户
      // 或者根据其他字段如 parentCustomer 等来判断
      return row.customerRelationType !== undefined && row.customerRelationType !== null
    },
    // 子级/直属客户：使用 standingList；父级/业务：使用 options.businessStanding
    getRowClevelText(row) {
      const level = row && row.customer ? row.customer.clevel : undefined
      const list = (this.isChildCustomer(row) || this.activeName === '2') ? this.standingList : this.options.businessStanding
      if (level === undefined || level === null || !Array.isArray(list)) return level
      const found = list.find(item => item.level === level || item.id === level || item.value === level)
      return found ? found.name : level
    },
    // 上级信息身份：统一按业务身份映射
    getParentClevelText(row) {
      const level = row && row.parentCustomer ? row.parentCustomer.clevel : undefined
      const list = this.options.businessStanding
      if (level === undefined || level === null || !Array.isArray(list)) return level
      const found = list.find(item => item.level === level || item.id === level || item.value === level)
      return found ? found.name : level
    },
    // 树形表格行 key
    getRowKey(row) {
      // 统一优先使用预生成的 _rowKey，兜底使用 customer.id 或 id
      return row && (row._rowKey || (row.customer ? row.customer.id : row.id))
    },
    // 懒加载团队子节点
    async loadTree(row, treeNode, resolve) {
      try {
        const params = { ywid: row.customer ? row.customer.id : '', areaid: this.rowId, pageSize: 100 }
        const { data } = await customerApi.getYwCustomer(params)
        let children = Array.isArray(data) ? data : (data && data.list) ? data.list : []
        // 仅一级可展开：二级子节点不再设置 hasChildren
        if (children && children.length > 0) {
          children = children.map((item, index) => ({
            ...item,
            hasChildren: false,
            _rowKey: (item && item.customer && item.customer.id) || item.id || `${this.getRowKey(row)}-${index}`
          }))
          resolve(children)
        } else {
          // 二级无数据时，返回占位子项，保持一级展开行可见
          resolve([
            {
              id: `${this.getRowKey(row)}-empty`,
              customer: { name: '暂无数据', pho: '' },
              hasChildren: false,
              isPlaceholder: true,
              _rowKey: `${this.getRowKey(row)}-empty`
            }
          ])
        }
      } catch (e) {
        // 异常时也返回占位，避免展开行消失
        resolve([
          {
            id: `${this.getRowKey(row)}-empty`,
            customer: { name: '暂无数据', pho: '' },
            hasChildren: false,
            isPlaceholder: true,
            _rowKey: `${this.getRowKey(row)}-empty`
          }
        ])
      }
    },
    // 获取客户身份
    getStandingList() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({ data
      }) => {
        this.standingList = data
      })
    },
    showArea(customer, num) {
      if (!num) return
      this.changeIdentity(customer)
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        customerType: 2
      }
      this.dateTime = []
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 分类筛选
     */
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query }
      this.listLoading = true
      query.areaid = this.rowId
      let Ins = this.activeName === '1' ? customerApi.getAreaYe : customerApi.getYwCustomer
      if (this.activeName === '2') query.ywid = this.rowId
      return Ins(query)
        .then(({ data }) => {
          // 顶层节点标记为可展开
          const list = data.list || []
          list.forEach((item, index) => {
            item.hasChildren = true
            item._rowKey = (item && item.customer && item.customer.id) || item.id || `root-${index}`
          })
          this.list = list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.options.businessStanding = data
      })
    },
    // 获取技术老师列表
    getTechnicianList() {
      // TODO: 需要导入 technicianInfoApi
      // technicianInfoApi.listForMini({
      //   // isGetAllParent: true
      // }).then(({data }) => {
      //   this.technicianList = data
      // })
      console.log('获取技术老师列表功能待实现')
    },
    handleClearCache(row) {
      this.$common.confirm('是否确认清除缓存')
        .then(() => userApi.delCache({ userId: row.customerUserPO.id }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    // 日志记录方法
    handleLog(row) {
      this.$router.push("/log/log?type=2&id=" + row.customer.id);
    },
    // 更新客户状态方法
    handleUpdate(row, type) {
      if (type === 1) {
        // 全部转为继承客户 - 包括该客户及其所有下级
        this.updateAllCustomerRelation(row, 0)
      } else if (type === 2) {
        // 全部转为开发客户 - 包括该客户及其所有下级
        this.updateAllCustomerRelation(row, 1)
      }
    },
    // 更新客户关系状态（单个客户）
    updateCustomerRelation(row, isOneselfDeveloped) {
      const customerIds = row.customer ? [row.customer.id] : []
      const params = {
        areaid: this.rowId,
        customerIds: customerIds,
        isOneselfDeveloped: isOneselfDeveloped,
        yeId: null
      }

      const actionText = isOneselfDeveloped === 1 ? '转为开发客户' : '转为继承客户'

      this.$common.confirm(`是否确认${actionText}？`)
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: `${actionText}中...`,
            background: 'rgba(0, 0, 0, 0.7)'
          })
          return customerApi.updateCustomerAreaRelation(params)
            .finally(() => {
              loading.close()
            })
        })
        .then(() => {
          this.$common.showMsg('success', `${actionText}成功`)
          this.forceRefresh(this.query.pageNo)
        })
    },
    // 单个客户状态更新（子级客户使用）
    handleSingleUpdate(row, isOneselfDeveloped) {
      this.updateCustomerRelation(row, isOneselfDeveloped)
    },
    // 更新全部客户关系状态（包括该客户及其所有下级）
    updateAllCustomerRelation(row, isOneselfDeveloped) {
      const params = {
        areaid: this.rowId,
        customerIds: [], // 空数组表示根据业务员批量设置
        isOneselfDeveloped: isOneselfDeveloped,
        yeId: row.customer ? row.customer.id : null // 使用业务员ID进行批量设置
      }

      const actionText = isOneselfDeveloped === 1 ? '全部转为开发客户' : '全部转为继承客户'

      this.$common.confirm(`是否确认${actionText}？此操作将影响该业务员及其所有下级客户。`)
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: `${actionText}中...`,
            background: 'rgba(0, 0, 0, 0.7)'
          })
          return customerApi.updateCustomerAreaRelation(params)
            .finally(() => {
              loading.close()
            })
        })
        .then(() => {
          this.$common.showMsg('success', `${actionText}成功`)
          this.forceRefresh(this.query.pageNo)
        })
    },
    // 导出方法
    handleDownload() {
      this.$router.push("/export/list?code=CustomerDownloadExcelDiy99")
    },
    // 批量操作 - 转为继承客户
    handleCreate() {
      if (this.selectItems.length === 0) {
        this.$common.showMsg('warning', '请选择要操作的客户')
        return
      }

      const customerIds = this.selectItems
        .filter(item => item.customer && item.customer.id)
        .map(item => item.customer.id)

      if (customerIds.length === 0) {
        this.$common.showMsg('warning', '没有有效的客户数据')
        return
      }

      const params = {
        areaid: this.rowId,
        customerIds: customerIds,
        isOneselfDeveloped: 0, // 转为继承客户
        yeId: null
      }

      this.$common.confirm('是否确认批量转为继承客户？').then(() => {
        const loading = this.$loading({
          lock: true,
          text: '批量转为继承客户中...',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        return customerApi.updateCustomerAreaRelation(params)
          .finally(() => {
            loading.close()
          })
      }).then(() => {
        this.$common.showMsg('success', '批量转为继承客户成功')
        this.forceRefresh(this.query.pageNo)
      })

    },
    // 批量操作 - 转为开发客户
    handleCreateDevelopment() {
      if (this.selectItems.length === 0) {
        this.$common.showMsg('warning', '请选择要操作的客户')
        return
      }

      const customerIds = this.selectItems
        .filter(item => item.customer && item.customer.id)
        .map(item => item.customer.id)

      if (customerIds.length === 0) {
        this.$common.showMsg('warning', '没有有效的客户数据')
        return
      }

      const params = {
        areaid: this.rowId,
        customerIds: customerIds,
        isOneselfDeveloped: 1, // 转为开发客户
        yeId: null
      }

      this.$common.confirm('是否确认批量转为开发客户？').then(() => {
        const loading = this.$loading({
          lock: true,
          text: '批量转为开发客户中...',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        return customerApi.updateCustomerAreaRelation(params)
          .finally(() => {
            loading.close()
          })
      }).then(() => {
        this.$common.showMsg('success', '批量转为开发客户成功')
        this.forceRefresh(this.query.pageNo)
      })
    },
    // 显示详情方法
    handleShow(row) {
      // TODO: 实现显示详情功能
      console.log('显示详情', row)
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .hide-selection-header .el-checkbox {
  visibility: hidden; /* 隐藏全选框，保留单元格空间，避免表格错位 */
}
.dialog-box {
  max-height: 70vh;
  overflow-y: auto;
}

.placeholder-text {
  color: #c0c4cc !important;
}

/* 父级复选框置灰样式 */
.el-table .el-checkbox.is-disabled .el-checkbox__input {
  cursor: not-allowed;
}

.el-table .el-checkbox.is-disabled .el-checkbox__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  cursor: not-allowed;
}

.el-table .el-checkbox.is-disabled .el-checkbox__inner:hover {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
}
</style>
